"use client"

import { useEffect, useState } from "react"
import Script from "next/script"
import {
  applyGoogleConsent,
  readStoredConsent,
} from "@lib/util/cookie-consent"

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID
const GA_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID

/** Load GTM/GA4 only after analytics or marketing consent. */
export default function ConsentAwareAnalytics() {
  const [allowTags, setAllowTags] = useState(false)

  useEffect(() => {
    const sync = () => {
      const stored = readStoredConsent()
      if (stored) {
        applyGoogleConsent(stored.categories)
        setAllowTags(
          !!(stored.categories.analytics || stored.categories.marketing)
        )
      } else {
        setAllowTags(false)
      }
    }

    sync()
    window.addEventListener("vx:cookie-consent-changed", sync)
    window.addEventListener("storage", sync)
    return () => {
      window.removeEventListener("vx:cookie-consent-changed", sync)
      window.removeEventListener("storage", sync)
    }
  }, [])

  if (!allowTags || (!GTM_ID && !GA_ID)) {
    return null
  }

  return (
    <>
      {GTM_ID ? (
        <>
          <Script id="vx-gtm" strategy="afterInteractive">{`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${GTM_ID}');
          `}</Script>
          <noscript>
            <iframe
              src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
              height="0"
              width="0"
              style={{ display: "none", visibility: "hidden" }}
              title="Google Tag Manager"
            />
          </noscript>
        </>
      ) : null}

      {!GTM_ID && GA_ID ? (
        <>
          <Script
            src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
            strategy="afterInteractive"
          />
          <Script id="vx-ga4" strategy="afterInteractive">{`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            window.gtag = gtag;
            gtag('js', new Date());
            gtag('config', '${GA_ID}', { anonymize_ip: true });
          `}</Script>
        </>
      ) : null}
    </>
  )
}